/** 
 * 图片使用华为云图片管理，
 * 请先使用压缩工具压缩，然后上传到对应目录下；
 * 复制链接
 */
const mx = 'https://static-mx.obs.myhuaweicloud.com/web/app-h5';
const af = 'https://static-af.obs.af-south-1.myhuaweicloud.com/web/app-h5';
const ms = '/h5/img'; // 墨西哥
// cons

// 仅有墨西哥&秘鲁的才使用墨西哥云 其他的都是南非服务
const CdnMap = {
  // 墨西哥
  'ipeso.cc': mx,
  'kabilcash.com': mx,
  'creavicash.com': mx,
  'maxcredito.cc': mx,
  'xcredito.cc': mx,
  'xfectivo.com': mx,
  'icredito.cc': mx, // 原5号包 更名为xcredito

  'mcredito.cc': mx,
  'justocredito.com': mx,
  'testhk10.xcreditech.com': mx,

  // 秘鲁
  'isolez.cc': mx,
  'cajaplatinka.com': mx,
  'www.cajaplatinka.com': mx,
  'testhk11.xcreditech.com': mx,

  // 哥伦比亚
  'parcecredit.com': mx,
  'credifio.cc': mx,
  'www.parcecredit.com': mx,
  'testhk15.xcreditech.com': mx,

  'tifi.com.mx': mx, // 工资贷
  'www.tifi.com.mx': mx,

  'credifio.com': mx,
  'www.credifio.com': mx,

  'creditaco.com': mx,
  'www.creditaco.com': mx,

  'testhk14.xcreditech.com': ms,
  'testhk16.xcreditech.com': af,
  'champloan.com': ms,
  'www.champloan.com': ms,
  'champloan.es': ms,
  'www.champloan.es': ms,
  'tifislice.com': af,
  'www.tifislice.com': af,

  'www.creditmoja.com': af,
  'localhost:3000': mx,
}

export const getLocalCdnLink = () => {
  const host = window.location.host
  // console.log(CdnMap[host]);
  window.$localCdnLink = CdnMap[host] || af
}
